import { render, staticRenderFns } from "./swap-battery-card-info.vue?vue&type=template&id=6d8e2ed8&scoped=true&lang=pug&"
import script from "./swap-battery-card-info.vue?vue&type=script&lang=js&"
export * from "./swap-battery-card-info.vue?vue&type=script&lang=js&"
import style0 from "./swap-battery-card-info.vue?vue&type=style&index=0&id=6d8e2ed8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8e2ed8",
  null
  
)

export default component.exports